/*
 * @Author: Yun
 * @Date: 2023-11-29 15:52:26
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-29 17:02:18
 */
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import firstLogo from '@icons/cgtn.jpg'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Button } from 'cgtd'
import audio_play_1 from './audio/audio-people.m4a'
import audio_play_2 from './audio/audio-eco.mp3'
import audio_play_3 from './audio/audio-deep.mp3'
import audio_play_4 from './audio/audio-tech.mp3'
import audio_play_5 from './audio/audio-culture.mp3'
import audio_play_6 from './audio/audio-ecology.mp3'
import './index.less'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Navigation } from 'swiper/core'
SwiperCore.use([Pagination, Navigation])
gsap.registerPlugin(ScrollTrigger)

window.jwplayer.key = '44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK'

let video_player_1 = null
let video_player_2 = null
let video_player_3 = null
let video_player_4 = null
let video_player_5 = null
let video_player_6 = null
let video_player_7 = null

const SwiperDemoPage = React.forwardRef((props, ref) => {
    const [pageIndex, setPageIndex] = useState(0)
    const [audio1, setAudio1] = useState(false)
    const [audio2, setAudio2] = useState(false)
    const [audio3, setAudio3] = useState(false)
    const [audio4, setAudio4] = useState(false)
    const [audio5, setAudio5] = useState(false)
    const [audio6, setAudio6] = useState(false)
    const [prevOp, setPrevOp] = useState(0.1)
    const [nextOp, setNextOp] = useState(1)
    const [isPlaying_1, setIsPlaying_1] = useState(false)
    const audioRef_1 = useRef(null)
    const [isPlaying_2, setIsPlaying_2] = useState(false)
    const audioRef_2 = useRef(null)
    const [isPlaying_3, setIsPlaying_3] = useState(false)
    const audioRef_3 = useRef(null)
    const [isPlaying_4, setIsPlaying_4] = useState(false)
    const audioRef_4 = useRef(null)
    const [isPlaying_5, setIsPlaying_5] = useState(false)
    const audioRef_5 = useRef(null)
    const [isPlaying_6, setIsPlaying_6] = useState(false)
    const audioRef_6 = useRef(null)

    let videoList = [
        'page-1-video',
        'page-2-video',
        'page-3-video',
        'page-4-video',
        'page-5-video',
        'page-6-video',
        'page-7-video',
        'SecondPage_video',
    ]

    useEffect(() => {
        swiperTimeline()

        video_player_1 = setJWplayer(document.querySelector('#page-1-video'), {
            video: 'https://video.cgtn.com/news/2024-04-24/Chongqing-advances-urban-renewal-with-intelligent-communities-1t3NsQIpTlm/video/1542c1cefe804f9d96bb0d4d121a31e6/1542c1cefe804f9d96bb0d4d121a31e6.mp4',
            poster: require('@images/backgrounds/people-title.jpg'),
            id: 'page-1-video',
        })

        video_player_2 = setJWplayer(document.querySelector('#page-2-video'), {
            video: 'https://video.cgtn.com/news/2024-12-13/Beijing-holds-annual-Central-Economic-Work-Conference-1ziNngt8oMM/video/wu_1ievuumri1flk1e4l1id3193o19cbte4/wu_1ievuumri1flk1e4l1id3193o19cbte4.mp4',
            poster: require('@images/greetings/eco-title.jpg'),
            id: 'page-2-video',
        })

        video_player_3 = setJWplayer(document.querySelector('#page-3-video'), {
            video: 'https://video.cgtn.com/news/2024-07-11/Xi-Jinping-leads-China-s-reform-and-opening-up-in-new-era-1v9PgAvbf0I/video/wu_1i2pr2f4m32gsqoelpfpp1cg4a/wu_1i2pr2f4m32gsqoelpfpp1cg4a.mp4',
            poster: require('@images/greetings/deep-title.png'),
            id: 'page-3-video',
        })

        video_player_4 = setJWplayer(document.querySelector('#page-4-video'), {
            video: 'https://video.cgtn.com/news/2024-10-20/President-Xi-Jinping-s-visits-to-Anhui-show-importance-of-sci-tech-innovation-1xQr8IwnFW8/video/wu_1iajur9ddkdv16p1fco1vea1hp8a73/wu_1iajur9ddkdv16p1fco1vea1hp8a73.mp4',
            poster: require('@images/greetings/tech-img.jpg'),
            id: 'page-4-video',
        })

        video_player_5 = setJWplayer(document.querySelector('#page-5-video'), {
            video: 'https://video.cgtn.com/news/2024-11-07/Xi-urges-cultural-relics-protection-at-Yunmeng-Xiangshan-Museum-1ykuOsZTjri/video/wu_1ic27pgnnruc15unc32k2h1jopa/wu_1ic27pgnnruc15unc32k2h1jopa.mp4',
            poster: require('@images/greetings/culture-title.png'),
            id: 'page-5-video',
        })

        video_player_6 = setJWplayer(document.querySelector('#page-6-video'), {
            video: 'https://video.cgtn.com/news/2024-09-12/Xi-Jinping-inspects-Lanzhou-in-NW-China-s-Gansu-Province-1wPDbTgp72g/video/wu_1i7l1esusqipcqq1t2v1dt31d19a/wu_1i7l1esusqipcqq1t2v1dt31d19a.mp4',
            poster: require('@images/greetings/ecology-title.jpg'),
            id: 'page-6-video',
        })
    }, [])

    useEffect(() => {
        if (pageIndex == 4) {
            video_player_7 = setJWplayer(document.querySelector('#page-7-video'), {
                video: 'https://video.cgtn.com/news/2024-07-27/UNESCO-names-Beijing-Central-Axis-a-World-Heritage-Site-1vzFzsT8xiM/video/wu_1i3pcbg811okkbus10d214lg46v6bq/wu_1i3pcbg811okkbus10d214lg46v6bq.mp4',
                poster: require('@images/greetings/culture-video-img.jpg'),
                id: 'page-7-video',
            })
        }
    }, [pageIndex])

    const swiperTimeline = () => {
        ScrollTrigger.create({
            trigger: '.swiper-demo-wrapper',
            start: 'top top+=6vw',
            // endTrigger: '#otherID',
            end: 'bottom 100%',
            toggleClass: {
                targets: '.swiper-demo-item-icon',
                className: 'swiper-demo-item-icon-active',
            },
        })
    }

    useImperativeHandle(ref, () => ({
        childMethod() {
            setAudio1(false)
            setAudio2(false)
            setAudio3(false)
            setAudio4(false)
            setAudio5(false)
            setAudio6(false)
            audioRef_1.current.pause()
            audioRef_2.current.pause()
            audioRef_3.current.pause()
            audioRef_4.current.pause()
            audioRef_5.current.pause()
            audioRef_6.current.pause()
            setIsPlaying_1(false)
            setIsPlaying_2(false)
            setIsPlaying_3(false)
            setIsPlaying_4(false)
            setIsPlaying_5(false)
            setIsPlaying_6(false)
        },
    }))

    const setJWplayer = (dom, data, opt) => {
        opt = opt || {}
        let instance

        try {
            instance = window
                .jwplayer(dom)
                .setup({
                    file: data.video,
                    image: data.poster,
                    // skin: {
                    //     name: 'nk-player'
                    // },
                    stretching: 'fill',
                    width: '42.5vw',
                    height: '24vw',
                    aspectratio: opt.ratio || '16:9',
                    androidhls: true,
                    primary: 'html5',
                    autostart: opt.autostart === 'true' ? true : false,
                    mute: opt.mute === 'true' ? true : false,
                    controls: opt.controls === 'false' ? false : true,
                    repeat: opt.repeat === 'true' ? true : false,
                    hlshtml: true,
                    base: process.env.PUBLIC_URL + '/jwplayer-8.12.5',
                    flashplayer: process.env.PUBLIC_URL + '/jwplayer-8.12.5/jwplayer.flash.swf',
                })
                .on('setupError', (e) => {
                    console.log('Setup Error...', e)
                })
                .on('play', () => {
                    // console.log('video play', data.id, opt)
                    // opt.onPlay && opt.onPlay()
                    setAudio1(false)
                    setAudio2(false)
                    setAudio3(false)
                    setAudio4(false)
                    setAudio5(false)
                    setAudio6(false)
                    audioRef_1.current.pause()
                    audioRef_2.current.pause()
                    audioRef_3.current.pause()
                    audioRef_4.current.pause()
                    audioRef_5.current.pause()
                    audioRef_6.current.pause()
                    setIsPlaying_1(false)
                    setIsPlaying_2(false)
                    setIsPlaying_3(false)
                    setIsPlaying_4(false)
                    setIsPlaying_5(false)
                    setIsPlaying_6(false)
                    props.closeSecondPageVideo()
                    props.closeGreetingsPageVideo()
                    for (let i = 0; i < videoList.length; i++) {
                        if (data.id !== videoList[i]) {
                            window.jwplayer(videoList[i]).pause()
                        }
                    }
                })
        } catch (error) {
            console.error('Setup JWplayer: ' + error)
        }

        return instance
    }

    const onSlideChange = (e) => {
        setPageIndex(e.activeIndex)
        props.setSwiperPageCurrentIndex(e.activeIndex)
        props.closeSwiperPageVideo()
        props.closeSecondPageVideo()
        props.closeGreetingsPageVideo()
        setAudio1(false)
        setAudio2(false)
        setAudio3(false)
        setAudio4(false)
        setAudio5(false)
        setAudio6(false)
        audioRef_1.current.pause()
        audioRef_2.current.pause()
        audioRef_3.current.pause()
        audioRef_4.current.pause()
        audioRef_5.current.pause()
        audioRef_6.current.pause()
        setIsPlaying_1(false)
        setIsPlaying_2(false)
        setIsPlaying_3(false)
        setIsPlaying_4(false)
        setIsPlaying_5(false)
        setIsPlaying_6(false)
        if (e.activeIndex == 0) {
            setPrevOp(0.1)
        } else {
            setPrevOp(1)
        }
        if (e.activeIndex == 5) {
            setNextOp(0.1)
        } else {
            setNextOp(1)
        }
    }

    const takeLink = (e) => {
        const element = document.getElementById('tag')

        if (element) {
            // console.log('yes')
            element.scrollIntoView()
        }
    }
    return (
        <div className="swiper-demo-wrapper" id="tag">
            <div className="top-div"></div>
            <a
                href="#tag"
                className="swiper-demo-item-icon-prev swiper-demo-item-icon"
                onClick={() => {
                    takeLink()
                }}
                style={{ opacity: prevOp }}
            ></a>
            <a
                href="#tag"
                className="swiper-demo-item-icon-next swiper-demo-item-icon"
                onClick={() => {
                    takeLink()
                }}
                style={{ opacity: nextOp }}
            ></a>
            <Swiper
                onSlideChange={onSlideChange}
                navigation={{
                    nextEl: `.swiper-demo-item-icon-next`,
                    prevEl: `.swiper-demo-item-icon-prev`,
                }}
                loop={false}
                // pagination={true}
                // onSwiper={(swiper) => onSwiper(swiper)}
                // onSlideChangeEnd={onSlideChangeEnd()}
            >
                <SwiperSlide key={0} tabIndex={0}>
                    <div className="swiper-page-item swiper-page-1">
                        <div className="page-1-title">
                            <div className="page-1-title-img"></div>
                            <span className="page-1-title-content">IN 2024</span>
                        </div>
                        <div className="page-1-banner">
                            Putting people at the center<div className="audio-icon"></div>
                        </div>
                        <div className="page-1-content-wrapper">
                            <div className="page-1-content-video">
                                <div id={'page-1-video'}></div>
                            </div>
                            <div className="page-1-content">
                                China forged ahead on the path to modernization on all fronts in
                                2024. But what makes Chinese-style modernization different from
                                models in developed countries?
                                <br />
                                <br />
                                For Chinese President Xi Jinping, the fundamental answer is simple –
                                putting people first, not capital.
                            </div>
                        </div>
                        <div className="audio-wrapper">
                            <div className="audio-controlor" id="audio_player_1">
                                <audio ref={audioRef_1} src={audio_play_1} />
                                <Button
                                    style={{
                                        borderRadius: '1vw',
                                        height: '1.8vw',
                                        display: 'flex',
                                        paddingTop: '0.1vw',
                                    }}
                                    onClick={() => {
                                        props.closeSecondPageVideo()
                                        props.closeGreetingsPageVideo()
                                        setAudio1(audio1 ? false : true)
                                        setAudio2(false)
                                        setAudio3(false)
                                        setAudio4(false)
                                        setAudio5(false)
                                        setAudio6(false)
                                        setIsPlaying_1(isPlaying_1 ? false : true)
                                        window.jwplayer('page-1-video').pause()
                                        window.jwplayer('page-2-video').pause()
                                        window.jwplayer('page-3-video').pause()
                                        window.jwplayer('page-4-video').pause()
                                        window.jwplayer('page-5-video').pause()
                                        window.jwplayer('page-6-video').pause()
                                        if (pageIndex === 4) {
                                            window.jwplayer('page-7-video').pause()
                                        }
                                        if (!isPlaying_1) {
                                            audioRef_1.current.play()
                                            audioRef_2.current.pause()
                                            audioRef_3.current.pause()
                                            audioRef_4.current.pause()
                                            audioRef_5.current.pause()
                                            audioRef_6.current.pause()
                                        } else {
                                            audioRef_1.current.pause()
                                        }
                                    }}
                                >
                                    {audio1 ? (
                                        <div className="over"></div>
                                    ) : (
                                        <div className="playing"></div>
                                    )}
                                    <div className="audio-button-content">LISTEN 07:08</div>
                                </Button>
                            </div>
                            <div className="audio-content">
                                The podcast is presented by Li Dongning.
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide key={1} tabIndex={1}>
                    <div className="swiper-page-item swiper-page-1">
                        <div className="page-1-title">
                            <div className="page-1-title-img"></div>
                            <span className="page-1-title-content">IN 2024</span>
                        </div>
                        <div className="page-1-banner">
                            Development remains top priority <div className="audio-icon"></div>
                        </div>
                        <div className="page-1-content-wrapper">
                            <div className="page-1-content-video">
                                <div id={'page-2-video'}></div>
                            </div>
                            <div className="page-1-content">
                                At major economic meetings and on regional inspections in 2024,
                                Chinese President Xi Jinping has repeatedly stressed the importance
                                of development.
                                <br />
                                <br />
                                At the Central Economic Work Conference – a key annual meeting
                                presided over by Xi – in December, it was stated that China has
                                ensured the overall stability and steady progress of the economy
                                this year, and that the major goals and tasks for economic and
                                social development in 2024 are expected to be accomplished.
                            </div>
                        </div>
                        <div className="audio-wrapper">
                            <div className="audio-controlor">
                                <audio ref={audioRef_2} src={audio_play_2} />
                                <Button
                                    style={{
                                        borderRadius: '1vw',
                                        height: '1.8vw',
                                        display: 'flex',
                                        paddingTop: '0.1vw',
                                    }}
                                    onClick={() => {
                                        props.closeSecondPageVideo()
                                        props.closeGreetingsPageVideo()
                                        setAudio1(false)
                                        setAudio2(audio2 ? false : true)
                                        setAudio3(false)
                                        setAudio4(false)
                                        setAudio5(false)
                                        setAudio6(false)
                                        setIsPlaying_2(isPlaying_2 ? false : true)
                                        window.jwplayer('page-1-video').pause()
                                        window.jwplayer('page-2-video').pause()
                                        window.jwplayer('page-3-video').pause()
                                        window.jwplayer('page-4-video').pause()
                                        window.jwplayer('page-5-video').pause()
                                        window.jwplayer('page-6-video').pause()
                                        if (pageIndex === 4) {
                                            window.jwplayer('page-7-video').pause()
                                        }
                                        if (!isPlaying_2) {
                                            audioRef_1.current.pause()
                                            audioRef_2.current.play()
                                            audioRef_3.current.pause()
                                            audioRef_4.current.pause()
                                            audioRef_5.current.pause()
                                            audioRef_6.current.pause()
                                        } else {
                                            audioRef_2.current.pause()
                                        }
                                    }}
                                >
                                    {audio2 ? (
                                        <div className="over"></div>
                                    ) : (
                                        <div className="playing"></div>
                                    )}
                                    <div className="audio-button-content">LISTEN 06:12</div>
                                </Button>
                            </div>
                            <div className="audio-content">
                                The podcast is presented by Liu Xin.
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide key={2} tabIndex={2}>
                    <div className="swiper-page-item swiper-page-1">
                        <div className="page-1-title">
                            <div className="page-1-title-img"></div>
                            <span className="page-1-title-content">IN 2024</span>
                        </div>
                        <div className="page-1-banner">
                            Major progress in deepening reform and opening up
                            <div className="audio-icon"></div>
                        </div>
                        <div className="page-1-content-wrapper">
                            <div className="page-1-content-video">
                                <div id={'page-3-video'}></div>
                            </div>
                            <div className="page-1-content">
                                China's mission to comprehensively deepen reform in the new era
                                continued apace in 2024, with the third plenary session of the 20th
                                Central Committee of the Communist Party of China (CPC) kickstarting
                                a new chapter in the new journey to promote Chinese modernization.
                            </div>
                        </div>
                        <div className="audio-wrapper">
                            <div className="audio-controlor">
                                <audio ref={audioRef_3} src={audio_play_3} />
                                <Button
                                    style={{
                                        borderRadius: '1vw',
                                        height: '1.8vw',
                                        display: 'flex',
                                        paddingTop: '0.1vw',
                                    }}
                                    onClick={() => {
                                        props.closeSecondPageVideo()
                                        props.closeGreetingsPageVideo()
                                        setAudio1(false)
                                        setAudio2(false)
                                        setAudio3(audio3 ? false : true)
                                        setAudio4(false)
                                        setAudio5(false)
                                        setAudio6(false)
                                        setIsPlaying_3(isPlaying_3 ? false : true)
                                        window.jwplayer('page-1-video').pause()
                                        window.jwplayer('page-2-video').pause()
                                        window.jwplayer('page-3-video').pause()
                                        window.jwplayer('page-4-video').pause()
                                        window.jwplayer('page-5-video').pause()
                                        window.jwplayer('page-6-video').pause()
                                        if (pageIndex === 4) {
                                            window.jwplayer('page-7-video').pause()
                                        }
                                        if (!isPlaying_3) {
                                            audioRef_1.current.pause()
                                            audioRef_2.current.pause()
                                            audioRef_3.current.play()
                                            audioRef_4.current.pause()
                                            audioRef_5.current.pause()
                                            audioRef_6.current.pause()
                                        } else {
                                            audioRef_3.current.pause()
                                        }
                                    }}
                                >
                                    {audio3 ? (
                                        <div className="over"></div>
                                    ) : (
                                        <div className="playing"></div>
                                    )}
                                    <div className="audio-button-content">LISTEN 06:14</div>
                                </Button>
                            </div>
                            <div className="audio-content">
                                The podcast is presented by Wang Mangmang.
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide key={3} tabIndex={3}>
                    <div className="swiper-page-item swiper-page-1">
                        <div className="page-1-title">
                            <div className="page-1-title-img"></div>
                            <span className="page-1-title-content">IN 2024</span>
                        </div>
                        <div className="page-1-banner">
                            Building an innovative nation<div className="audio-icon"></div>
                        </div>
                        <div className="page-1-content-wrapper">
                            <div className="page-1-content-video">
                                <div id={'page-4-video'}></div>
                            </div>
                            <div className="page-1-content">
                                With double-digit growth in the production of new energy vehicles,
                                integrated circuits and service robots in 2024, momentum continued
                                to grow behind China's innovation economy.
                                <br />
                                <br />
                                As Chinese President Xi Jinping emphasized during a visit to Hefei
                                City in Anhui Province in October, "science and technology should be
                                at the forefront in advancing Chinese modernization."
                            </div>
                        </div>
                        <div className="audio-wrapper">
                            <div className="audio-controlor">
                                <audio ref={audioRef_4} src={audio_play_4} />
                                <Button
                                    style={{
                                        borderRadius: '1vw',
                                        height: '1.8vw',
                                        display: 'flex',
                                        paddingTop: '0.1vw',
                                    }}
                                    onClick={() => {
                                        props.closeSecondPageVideo()
                                        props.closeGreetingsPageVideo()
                                        setAudio1(false)
                                        setAudio2(false)
                                        setAudio3(false)
                                        setAudio4(audio4 ? false : true)
                                        setAudio5(false)
                                        setAudio6(false)
                                        setIsPlaying_4(isPlaying_4 ? false : true)
                                        window.jwplayer('page-1-video').pause()
                                        window.jwplayer('page-2-video').pause()
                                        window.jwplayer('page-3-video').pause()
                                        window.jwplayer('page-4-video').pause()
                                        window.jwplayer('page-5-video').pause()
                                        window.jwplayer('page-6-video').pause()
                                        if (pageIndex === 4) {
                                            window.jwplayer('page-7-video').pause()
                                        }
                                        if (!isPlaying_4) {
                                            audioRef_1.current.pause()
                                            audioRef_2.current.pause()
                                            audioRef_3.current.pause()
                                            audioRef_4.current.play()
                                            audioRef_5.current.pause()
                                            audioRef_6.current.pause()
                                        } else {
                                            audioRef_4.current.pause()
                                        }
                                    }}
                                >
                                    {audio4 ? (
                                        <div className="over"></div>
                                    ) : (
                                        <div className="playing"></div>
                                    )}
                                    <div className="audio-button-content">LISTEN 03:54</div>
                                </Button>
                            </div>
                            <div className="audio-content">
                                The podcast is presented by Wang Guan.
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide key={4} tabIndex={4}>
                    <div className="swiper-page-item swiper-page-1">
                        <div className="page-1-title">
                            <div className="page-1-title-img"></div>
                            <span className="page-1-title-content">IN 2024</span>
                        </div>
                        <div className="page-1-banner">
                            Protecting and inheriting rich cultural heritage
                            <div className="audio-icon"></div>
                        </div>
                        <div className="page-1-content-wrapper">
                            <div className="page-1-content-video">
                                <div id={'page-5-video'}></div>
                            </div>
                            <div className="page-1-content">
                                In 2024, Chinese President Xi Jinping mentioned culture more than
                                100 times during his domestic inspection tours. When inspecting
                                Yunmeng Xiangshan Museum in central China's Hubei Province in
                                November, Xi admired the ancient bamboo slips and called on local
                                authorities to protect and study them carefully.
                            </div>
                        </div>
                        <div className="audio-wrapper">
                            <div className="audio-controlor">
                                <audio ref={audioRef_5} src={audio_play_5} />
                                <Button
                                    style={{
                                        borderRadius: '1vw',
                                        height: '1.8vw',
                                        display: 'flex',
                                        paddingTop: '0.1vw',
                                    }}
                                    onClick={() => {
                                        props.closeSecondPageVideo()
                                        props.closeGreetingsPageVideo()
                                        setAudio1(false)
                                        setAudio2(false)
                                        setAudio3(false)
                                        setAudio4(false)
                                        setAudio5(audio5 ? false : true)
                                        setAudio6(false)
                                        setIsPlaying_5(isPlaying_5 ? false : true)
                                        window.jwplayer('page-1-video').pause()
                                        window.jwplayer('page-2-video').pause()
                                        window.jwplayer('page-3-video').pause()
                                        window.jwplayer('page-4-video').pause()
                                        window.jwplayer('page-5-video').pause()
                                        window.jwplayer('page-6-video').pause()
                                        if (pageIndex === 4) {
                                            window.jwplayer('page-7-video').pause()
                                        }
                                        if (!isPlaying_5) {
                                            audioRef_1.current.pause()
                                            audioRef_2.current.pause()
                                            audioRef_3.current.pause()
                                            audioRef_4.current.pause()
                                            audioRef_5.current.play()
                                            audioRef_6.current.pause()
                                        } else {
                                            audioRef_5.current.pause()
                                        }
                                    }}
                                >
                                    {audio5 ? (
                                        <div className="over"></div>
                                    ) : (
                                        <div className="playing"></div>
                                    )}
                                    <div className="audio-button-content">LISTEN 04:54</div>
                                </Button>
                            </div>
                            <div className="audio-content">
                                The podcast is presented by Philip Hampsheir.
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide key={5} tabIndex={5}>
                    <div className="swiper-page-item swiper-page-1">
                        <div className="page-1-title">
                            <div className="page-1-title-img"></div>
                            <span className="page-1-title-content">IN 2024</span>
                        </div>
                        <div className="page-1-banner">
                            Pushing for more lucid water and lush mountains
                            <div className="audio-icon"></div>
                        </div>
                        <div className="page-1-content-wrapper">
                            <div className="page-1-content-video">
                                <div id={'page-6-video'}></div>
                            </div>
                            <div className="page-1-content">
                                Chinese President Xi Jinping continued to stress the importance of
                                ecological and environmental governance during his domestic
                                inspections in 2024.
                                <br />
                                <br />
                                "Protection is a precondition of development, and lucid waters and
                                lush mountains are invaluable assets," Xi said when inspecting a
                                section of the Yellow River in northwest China's Gansu Province in
                                September.
                            </div>
                        </div>
                        <div className="audio-wrapper">
                            <div className="audio-controlor">
                                <audio ref={audioRef_6} src={audio_play_6} />
                                <Button
                                    style={{
                                        borderRadius: '1vw',
                                        height: '1.8vw',
                                        display: 'flex',
                                        paddingTop: '0.1vw',
                                    }}
                                    onClick={() => {
                                        props.closeSecondPageVideo()
                                        props.closeGreetingsPageVideo()
                                        setAudio1(false)
                                        setAudio2(false)
                                        setAudio3(false)
                                        setAudio4(false)
                                        setAudio5(false)
                                        setAudio6(audio6 ? false : true)
                                        setIsPlaying_6(isPlaying_6 ? false : true)
                                        window.jwplayer('page-1-video').pause()
                                        window.jwplayer('page-2-video').pause()
                                        window.jwplayer('page-3-video').pause()
                                        window.jwplayer('page-4-video').pause()
                                        window.jwplayer('page-5-video').pause()
                                        window.jwplayer('page-6-video').pause()
                                        if (pageIndex === 4) {
                                            window.jwplayer('page-7-video').pause()
                                        }
                                        if (!isPlaying_6) {
                                            audioRef_1.current.pause()
                                            audioRef_2.current.pause()
                                            audioRef_3.current.pause()
                                            audioRef_4.current.pause()
                                            audioRef_5.current.pause()
                                            audioRef_6.current.play()
                                        } else {
                                            audioRef_6.current.pause()
                                        }
                                    }}
                                >
                                    {audio6 ? (
                                        <div className="over"></div>
                                    ) : (
                                        <div className="playing"></div>
                                    )}
                                    <div className="audio-button-content">LISTEN 05:21</div>
                                </Button>
                            </div>
                            <div className="audio-content">
                                The podcast is presented by Luo Laiming.
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
            {pageIndex == 0 && (
                <div>
                    <div className="page-1-1">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-1"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Serving the people</div>
                                <div className="content-1-1">
                                    According to China's Ministry of Finance, 70 percent of
                                    government expenditure in 2024 has gone toward ensuring the
                                    people's well-being.
                                    <br />
                                    <br />
                                    The country has raised its expenditure in the national general
                                    public budget to about 28.55 trillion yuan ($3.91 trillion) this
                                    year, up 4 percent from the previous year, with projected
                                    budgets for education, social insurance and employment each
                                    surpassing 4 trillion yuan in 2024.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-1-2">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-2"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">A bumper harvest</div>
                                <div className="content-1-2">
                                    The latest National Bureau of Statistics of China data showed
                                    that in 2024 the country's total grain output exceeded 706
                                    million tonnes, an increase of 1.6 percent over the previous
                                    year, hitting a new record high.
                                    <br />
                                    <br />
                                    This year's bumper harvest was accompanied by a rise in grain
                                    planting areas in the country, which stood at over 119 million
                                    hectares, up 0.3 percent year on year. Additionally, grain
                                    output per unit area increased by 1.3 percent, the data showed.
                                    <br />
                                    <br />
                                    In another positive development, China's food security law,
                                    aimed at ensuring the supply of grain and related products, took
                                    effect in June.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-1-3">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-3"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Accelerating rural revitalization </div>
                                <div className="content-1-3">
                                    China has identified 160 major counties for national rural
                                    revitalization assistance and allocated over 177 billion yuan in
                                    subsidies to support their development in 2024.
                                    <br />
                                    <br />
                                    In the first three quarters of this year, the per capita
                                    disposable income of rural residents reached 16,740 yuan, a
                                    real-term annual increase of 6.3 percent.
                                    <br />
                                    <br />
                                    Meanwhile, the central government allocated development funds of
                                    7.4 billion yuan to improve production and living conditions in
                                    ethnic minority villages and to protect and develop ethnic
                                    minority villages.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-1-4">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-4"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">
                                    Progress in consolidating poverty alleviation
                                </div>
                                <div className="content-1-4">
                                    The country launched monitoring and support mechanisms to
                                    prevent once poor populations from falling back into poverty. By
                                    the end of September, around 60 percent of these people no
                                    longer faced such risks and others had received assistance and
                                    support.
                                    <br />
                                    <br />
                                    Work-relief programs to boost employment have also been
                                    implemented this year. In the first three quarters, these
                                    programs created a total of 2.45 million jobs for low-income
                                    workers, a year-on-year increase of 30.2 percent, and
                                    distributed 31 billion yuan in wages, up 22.7 percent from a
                                    year earlier, according to the National Development and Reform
                                    Commission.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 1 && (
                <div>
                    <div className="eco-page-1-1">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-1"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Stability and progress</div>
                                <div className="content-1-1">
                                    Official numbers highlight both a stable foundation of the
                                    Chinese economy and promising progress in emerging sectors.
                                    <br />
                                    <br />
                                    Growth rates, both cumulative and quarterly, have shown minimal
                                    fluctuations, consistently hovering around the 5 percent target.
                                    Indicators of development quality also present a positive
                                    outlook: in the first three quarters, the value-added output of
                                    high-tech manufacturing industries above the designated size
                                    grew by 9.1 percent year on year, while investment in high-tech
                                    industries weres up by 10 percent.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="eco-page-1-2">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-2"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Stimulus measures</div>
                                <div className="content-1-2">
                                    Since late September, the central government has unveiled what
                                    experts say is a package of "milestone macroeconomic measures."
                                    <br />
                                    <br />
                                    These efforts, including a program of large-scale equipment
                                    upgrades and trade-ins of consumer goods, supportive real estate
                                    policies and the issuance of ultra-long special treasury bonds
                                    and local government special bonds, have helped boost domestic
                                    demand and strengthen the economic impetus.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="eco-page-1-3">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-3"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Regional development </div>
                                <div className="content-1-3">
                                    Regional development has also picked up across China. During his
                                    inspection tours, Xi called on and instructed local authorities
                                    to strengthen the implementation of regional strategies and
                                    boost regional development.
                                    <br />
                                    <br />
                                    On June 30, the Shenzhen-Zhongshan Link, a mega cross-sea
                                    passage in south China, opened to traffic. The link is the
                                    latest major transportation project completed in the
                                    Guangdong-Hong Kong-Macao Greater Bay Area (GBA), following the
                                    Hong Kong-Zhuhai-Macao Bridge.
                                    <br />
                                    <br />
                                    By improving the flow of people and goods on both banks of the
                                    Pearl River estuary within a "one-hour living circle," the link
                                    is expected to inject new impetus into the integrated
                                    development of the GBA.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="eco-page-1-4">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-4"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">High-standard opening up</div>
                                <div className="content-1-4">
                                    In March, China issued an action plan that proposed measures
                                    including shortening its negative list for foreign investment
                                    reasonably to promote high-standard opening up and make greater
                                    efforts to attract and utilize foreign investment.
                                    <br />
                                    <br />
                                    The country also promised to give all least developed countries
                                    with which it has diplomatic relations zero-tariff treatment for
                                    100 percent tariff lines as of December 1.
                                    <br />
                                    <br />
                                    Starting July 30, China's total trade in goods has ranked first
                                    in the world for the seventh year in a row. China has also
                                    become a major trading partner of more than 150 countries and
                                    regions, said the General Administration of Customs.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 2 && (
                <div>
                    <div className="deep-page-1-1">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-1"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Over 300 measures</div>
                                <div className="content-1-1">
                                    The depth and breadth of China's reform in 2024 was outlined in
                                    a resolution on further deepening reform comprehensively
                                    featuring 60 clauses and over 300 measures, spanning from
                                    economic, political, cultural and social issues to national
                                    security and the defense and military sectors, that was approved
                                    at the third plenary session of the 20th CPC Central Committee
                                    in July.
                                    <br />
                                    <br />
                                    After the plenary session, moves to swiftly implement the
                                    measures began. China's Ministry of Justice and the National
                                    Development and Reform Commission (NDRC) published a draft of
                                    the private sector promotion law to solicit public opinion in
                                    October. If passed, it will be China's first foundational law
                                    specifically focused on the development of the private economy.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="deep-page-1-2">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-2"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Incremental measures</div>
                                <div className="content-1-2">
                                    China has rolled out a series of incremental measures this year,
                                    including increasing local government debt quotas to replace
                                    hidden debt, easing real-estate regulations, directing long-term
                                    capital into the market and increasing support for struggling
                                    businesses.
                                    <br />
                                    <br />
                                    In November, Chinese lawmakers approved a State Council bill on
                                    raising the ceiling on local government debt by 6 trillion yuan
                                    (about $840 billion) to replace existing hidden debts. Under
                                    this arrangement, the debt ceiling for special local government
                                    debt will be increased to 35.52 trillion yuan from 29.52
                                    trillion yuan by the end of 2024.
                                    <br />
                                    <br />
                                    Also starting from 2024, China has set aside 800 billion yuan
                                    from each year's new special-purpose bonds for local governments
                                    for five consecutive years, thereby providing debt relief to
                                    replace 4 trillion yuan of hidden debts.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="deep-page-1-3">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-3"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Expanding trading partners</div>
                                <div className="content-1-3">
                                    This year, China's major trading partners have increased from
                                    over 140 countries and regions to more than 150.
                                    <br />
                                    <br />
                                    According to the General Administration of Customs, China's
                                    total goods imports and exports expanded to 39.79 trillion yuan
                                    ($5.6 trillion), in the first 11 months of the year,
                                    representing a 4.9 percent year-on-year increase.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="deep-page-1-4">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-4"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Opportunities for all</div>
                                <div className="content-1-4">
                                    The number of items on China's latest negative list, which
                                    specifies fields that are off-limits to foreign investors, has
                                    been slashed to 29. The country has removed all market access
                                    restrictions for foreign investors in the manufacturing sector,
                                    and vowed to widen market access and advance openness in the
                                    telecommunications, education, culture and healthcare sectors.
                                    <br />
                                    <br />
                                    The establishment of wholly foreign-owned hospitals is now
                                    permitted in nine cities and foreign investors are also allowed
                                    to operate fully-owned businesses in other areas, including data
                                    centers and online data processing.
                                    <br />
                                    <br />
                                    China also offers zero-tariff treatment for 100 percent tariff
                                    lines to all the least developed countries with which it holds
                                    diplomatic relations.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 3 && (
                <div>
                    <div className="tech-page-1-1">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-1"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">
                                    Major strides in technological innovation
                                </div>
                                <div className="content-1-1">
                                    China's global innovation ranking rose to 11th place, up one
                                    compared to last year, in the World Intellectual Property
                                    Organization's 2024 index, cementing its status as one of the
                                    fastest-growing economies in terms of innovation over the past
                                    decade.
                                    <br />
                                    <br />
                                    China now has 26 of the world's top 100 science and technology
                                    innovation clusters, surpassing last year's 24, and ranks first
                                    globally for the second consecutive year.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tech-page-1-2">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-2"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">New quality productive forces</div>
                                <div className="content-1-2">
                                    Meanwhile, regions across the country are seeking to drive the
                                    development of new quality productive forces. Beijing, for
                                    example, is building an international science and technology
                                    innovation center, advancing in emerging fields like 6G and
                                    quantum technologies, while Liaoning is strengthening 12 key
                                    industrial clusters, with a focus on aerospace equipment
                                    manufacturing.
                                    <br />
                                    <br />
                                    In the first half of 2024, investment in high-tech industries
                                    increased by 10.6 percent year on year, outpacing total
                                    investment growth by 6.7 percentage points. Emerging sectors
                                    such as next-generation information technology, artificial
                                    intelligence, new energy, new materials and high-end equipment
                                    are emerging as new growth drivers.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tech-page-1-3">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-3"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Enterprises driving innovation</div>
                                <div className="content-1-3">
                                    According to the latest official report, centrally administered
                                    enterprises have intensified efforts to tackle key and core
                                    technologies, implementing 11 special action plans and
                                    establishing an overall framework for creating 201 original
                                    technology hubs in eight major categories and 60 fields.
                                    <br />
                                    <br />
                                    They have also helped build the national laboratory system,
                                    leading the reorganization of several national key laboratories
                                    and advancing the construction of innovation consortia. This has
                                    driven collaboration among over 500 universities, research
                                    institutes, local state-owned enterprises and private
                                    enterprises to jointly promote more than 1,000 cooperative
                                    projects.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="tech-page-1-4">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-4"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">
                                    "Patient capital" providing strong support
                                </div>
                                <div className="content-1-4">
                                    "Patient capital," characterized by a preference for long-term
                                    returns, complements the technological innovation process well
                                    with its high barriers, long cycles and high risks.
                                    <br />
                                    <br />
                                    From the proposal of Political Bureau of the Communist Party of
                                    China (CPC) Central Committee to expand patient capital in
                                    April, to the 20th CPC Central Committee's Third Plenary
                                    Session's explicit emphasis on its development in July, its role
                                    in supporting China's technological innovation is increasingly
                                    significant.
                                    <br />
                                    <br />
                                    As a key component of patient capital, state-owned capital
                                    investment has increased this year, promoting technological
                                    breakthroughs in advanced manufacturing, energy and electronic
                                    information, yielding positive results.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 4 && (
                <div>
                    <div className="culture-page-1-1">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-1"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">
                                    44 items on UNESCO's Intangible Cultural Heritage List
                                </div>
                                <div className="content-1-1">
                                    China has 44 items on UNESCO's Intangible Cultural Heritage
                                    List, the highest in the world.
                                    <br />
                                    <br />
                                    Since the 18th National Congress of the Communist Party of
                                    China, the country has achieved remarkable results in the
                                    preservation of intangible cultural heritage.
                                    <br />
                                    <br />
                                    After years of effort, China is home to over 760,000 immovable
                                    cultural relics and maintains a four-tier intangible cultural
                                    heritage inventory, recognizing over 100,000 representative
                                    items and 90,000 inheritors, according to the Ministry of
                                    Culture and Tourism.
                                </div>
                            </div>
                        </div>
                        <div id={'page-7-video'}></div>
                    </div>
                    <div className="culture-page-1-2">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-2"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Cultural tourism: A pillar industry</div>
                                <div className="content-1-2">
                                    Cultural tourism emerged as a highlight during this year's
                                    holidays. Trends such as Zibo barbecue, Luoyang Hanfu, Guizhou's
                                    "Village BA" basketball tournaments and “Erbin” festivities
                                    gained nationwide popularity. Coupled with concerts, festivals
                                    and fireworks displays, these phenomena spurred tourism in
                                    various regions across the country.
                                    <br />
                                    <br />
                                    Museums have also been gaining popularity among the Chinese. In
                                    2023, visits to museums across China reached 1.29 billion,
                                    surpassing previous years.
                                    <br />
                                    <br />
                                    China's expanding visa-free policy has sparked a "China Travel"
                                    boom. In the third quarter of 2024, 8.19 million foreigners
                                    entered China, an increase of 48.8 percent year on year. Of
                                    these, 4.89 million entered visa-free, up 78.6 percent.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="culture-page-1-3">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-3"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Building a cultural powerhouse</div>
                                <div className="content-1-3">
                                    Cultural prosperity is a strong pillar for national
                                    rejuvenation. China aims to shape itself into a cultural
                                    powerhouse by 2035.
                                    <br />
                                    <br />
                                    According to the National Bureau of Statistics, 73,000
                                    large-scale cultural enterprises nationwide generated a revenue
                                    of 12.95 trillion yuan (about $1.8 trillion) in 2023, reflecting
                                    an 8.2 percent increase from the previous year. Furthermore, per
                                    capita expenditure on education, culture and entertainment for
                                    Chinese residents reached 2,904 yuan, up 17.6 percent year on
                                    year and accounting for 10.8 percent of total per capita
                                    consumption expenditure.
                                    <br />
                                    <br />
                                    National art creation and production continued to flourish and
                                    the public service system continued to improve. By the end of
                                    2023, there were 44,000 mass cultural institutions across the
                                    country, employing 199,000 people.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="culture-page-1-4">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-4"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">
                                    Integration of culture, technology picks up steam
                                </div>
                                <div className="content-1-4">
                                    New cultural industries characterized by digitization,
                                    networking and intelligence have developed rapidly in recent
                                    years in China, according to a report by the National Bureau of
                                    Statistics on the country's socioeconomic development over the
                                    past 75 years.
                                    <br />
                                    <br />
                                    Emerging cultural industries based on the internet and mobile
                                    internet, such as digital content, animation and games, video
                                    streaming, online performances and digital publishing, are
                                    continuously demonstrating their development potential and
                                    becoming new driving forces and growth points for the cultural
                                    industry.
                                    {/* <br />
                                    <br />
                                    An apt example of the integration of new technology and
                                    traditional Chinese culture is the video game Black Myth:
                                    Wukong, which many consider a "milestone" in the Chinese gaming
                                    industry. Released on August 20, the game has acquired immense
                                    popularity on major gaming platforms. On Steam, a leading gaming
                                    platform, it occupied top spot on the global chart. Within an
                                    hour of being officially uploaded on Steam, the game had more
                                    than 1 million concurrent players. */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {pageIndex == 5 && (
                <div>
                    <div className="ecology-page-1-1">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-1"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">
                                    The Yellow River is more and more beautiful
                                </div>
                                <div className="content-1-1">
                                    Since the 18th National Congress of the Communist Party of
                                    China, Xi Jinping has inspected nine provinces and autonomous
                                    regions along the Yellow River dozens of times, promoting
                                    continuous progress in ecological conservation and high-quality
                                    development of the river basin.
                                    <br />
                                    <br />
                                    Known as China’s “mother river,” the Yellow River has flowed
                                    continuously without interruption since August 1999, thanks to
                                    the unified allocation of water resources, according to the
                                    Ministry of Water Resources. Over the past 25 years, the main
                                    stream of the Yellow River has supplied more than 543.6 billion
                                    cubic meters of water to the basin and surrounding areas,
                                    effectively supporting the stable economic and social
                                    development of the region.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ecology-page-1-2">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-2"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Protecting "Third Pole of Earth"</div>
                                <div className="content-1-2">
                                    The Qinghai-Xizang Plateau ecosystem absorbs 162 million tonnes
                                    of carbon annually, accounting for 8 to 16 percent of China's
                                    total ecological carbon sequestration, and this proportion is
                                    expected to grow further.
                                    <br />
                                    <br />
                                    The plateau has developed an initial system of protected natural
                                    areas, with national parks as the mainstay, nature reserves as
                                    the foundation, and various nature parks as supplements.
                                    <br />
                                    <br />
                                    Since the second Qinghai-Xizang scientific expedition began in
                                    2017, researchers have discovered over 3,000 new species. The
                                    scientific findings reveal that the plateau has achieved overall
                                    carbon neutrality, thanks to the growth of green, low-carbon
                                    industries such as clean energy.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ecology-page-1-3">
                        <div className="content-2">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-3"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">
                                    Marked improvement in marine ecosystems
                                </div>
                                <div className="content-1-3">
                                    China is a major maritime country and one of the countries with
                                    the richest marine biodiversity in the world. The country has
                                    documented over 28,000 marine species, accounting for 11 percent
                                    of the world's total known marine species.
                                    <br />
                                    <br />
                                    In June, China issued the first "China Marine Ecological Early
                                    Warning and Monitoring Bulletin." The monitoring results showed
                                    that the overall conditions of ecosystems, such as coral reefs,
                                    seagrass beds, coastal salt marshes and mangroves, are
                                    predominantly good to excellent.
                                    <br />
                                    <br />
                                    By promoting the protection and restoration of marine
                                    ecosystems, the total area of mangroves has increased to 438,000
                                    mu (29,200 hectares), making China one of the few countries with
                                    a net increase in mangrove coverage.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ecology-page-1-4">
                        <div className="content-1">
                            <div className="content-wrapper">
                                <div className="obj-wrapper">
                                    <div className="obj-1-4"></div>
                                    <div className="obj-underline"></div>
                                </div>
                                <div className="obj-title">Biodiversity protection in China</div>
                                <div className="content-1-4">
                                    As a mega-biodiverse country and one of the earliest signatories
                                    and ratifiers of the Convention on Biological Diversity, China
                                    places great emphasis on biodiversity conservation.
                                    <br />
                                    <br />
                                    In January, China updated and released the National Biodiversity
                                    Conservation Strategy and Action Plan (2023-30), aligning it
                                    with the global goals of the Kunming-Montreal Global
                                    Biodiversity Framework.
                                    <br />
                                    <br />
                                    So far, China has taken the lead in establishing an ecological
                                    protection redline system, covering more than 30 percent of the
                                    country's total land area. Additionally, 90 percent of China's
                                    terrestrial ecosystem types and 74 percent of key protected wild
                                    animal and plant species populations are now effectively
                                    safeguarded.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
})

export default SwiperDemoPage
